import { MAX_CELL_WIDTH } from "ds/components/Table/constants";
import { TableColumnMeta } from "ds/components/Table/types";

export enum STACK_PULL_REQUESTS_COLUMN_ID {
  STATUS = "STATUS",
  TITLE = "TITLE",
  AUTHOR = "AUTHOR",
  PR = "PR",
  BRANCH = "BRANCH",
  DELTA = "DELTA",
  CREATED_AT = "CREATED_AT",
  ROW_ACTIONS = "ROW_ACTIONS",
}

export const STACK_PULL_REQUESTS_TABLE_STORAGE_KEY = "stackPullRequestsColumnsConfig";

export const STACK_PULL_REQUESTS_TABLE_COLUMNS_CONFIG: Record<
  STACK_PULL_REQUESTS_COLUMN_ID,
  TableColumnMeta
> = {
  [STACK_PULL_REQUESTS_COLUMN_ID.STATUS]: {
    id: STACK_PULL_REQUESTS_COLUMN_ID.STATUS,
    title: "Status",
    minWidth: 180,
    defaultWidth: 180,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
    configurable: true,
  },
  [STACK_PULL_REQUESTS_COLUMN_ID.TITLE]: {
    id: STACK_PULL_REQUESTS_COLUMN_ID.TITLE,
    title: "Title",
    minWidth: 180,
    defaultWidth: 350,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: false,
    canPin: true,
    canMove: true,
    configurable: true,
  },
  [STACK_PULL_REQUESTS_COLUMN_ID.AUTHOR]: {
    id: STACK_PULL_REQUESTS_COLUMN_ID.AUTHOR,
    title: "Author",
    minWidth: 120,
    defaultWidth: 180,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
    configurable: true,
  },
  [STACK_PULL_REQUESTS_COLUMN_ID.PR]: {
    id: STACK_PULL_REQUESTS_COLUMN_ID.PR,
    title: "PR",
    minWidth: 110,
    defaultWidth: 130,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
    configurable: true,
  },
  [STACK_PULL_REQUESTS_COLUMN_ID.BRANCH]: {
    id: STACK_PULL_REQUESTS_COLUMN_ID.BRANCH,
    title: "Branch",
    minWidth: 120,
    defaultWidth: 220,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
    configurable: true,
  },
  [STACK_PULL_REQUESTS_COLUMN_ID.DELTA]: {
    id: STACK_PULL_REQUESTS_COLUMN_ID.DELTA,
    title: "Delta",
    minWidth: 150,
    defaultWidth: 180,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
    configurable: true,
  },
  [STACK_PULL_REQUESTS_COLUMN_ID.CREATED_AT]: {
    id: STACK_PULL_REQUESTS_COLUMN_ID.CREATED_AT,
    title: "Created at",
    minWidth: 150,
    defaultWidth: 200,
    maxWidth: MAX_CELL_WIDTH,
    allowsSorting: false,
    resizable: true,
    canHide: true,
    canPin: true,
    canMove: true,
    configurable: true,
  },
  [STACK_PULL_REQUESTS_COLUMN_ID.ROW_ACTIONS]: {
    id: STACK_PULL_REQUESTS_COLUMN_ID.ROW_ACTIONS,
    title: "Pull request actions",
    noHeader: true,
    minWidth: 60,
    defaultWidth: 60,
    maxWidth: 60,
    resizable: false,
    canHide: false,
    canPin: false,
    canMove: false,
    configurable: false,
  },
};
